import { NgModule } from '@angular/core';
import { ReconnectSettingModalComponent } from './reconnect-setting-modal.component';
import { CommonModule } from '@angular/common';
import { SiModalModule } from '../../../../../shared/components';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule,
        SiModalModule
    ],
    declarations: [ReconnectSettingModalComponent],
    exports: [ReconnectSettingModalComponent],
})
export class ReconnectSettingModalModule {}
